// extracted by mini-css-extract-plugin
module.exports = {"exchangeHeaderFees":"aEAoiE","infoColumn":"o07UGs","feesLabel":"d42U49","feesValue":"lo3_5u","last":"VBBlTS"};